import React, { useEffect } from 'react';
import { useAuth } from "react-oidc-context";
import HeaderBar from "./components/HeaderBar";
import SearchComponent from "./components/SearchComponent";

const ProtectedRoute = ({ children }) => {
    const auth = useAuth();

    // Event Listener für abgelaufene Tokens ---
    useEffect(() => {
        // Diese Funktion wird aufgerufen, wenn der Timer (z.B. 60 Min) abläuft
        const onTokenExpired = () => {
            console.warn("⚠️ Token ist abgelaufen! Automatische Umleitung zum Login...");
            auth.signinRedirect(); // Schickt den User sofort zu OneLogin
        };

        // Event registrieren
        auth.events.addAccessTokenExpired(onTokenExpired);

        // Cleanup: Event entfernen, wenn die App geschlossen wird
        return () => {
            auth.events.removeAccessTokenExpired(onTokenExpired);
        };
    }, [auth.events, auth.signinRedirect]);

    // 1. Automatisch zum Login leiten, wenn nicht eingeloggt
    useEffect(() => {
        // Wenn nicht geladen, kein Fehler und nicht eingeloggt -> Redirect
        if (!auth.isLoading && !auth.error && !auth.isAuthenticated) {
            auth.signinRedirect();
        }
    }, [auth.isLoading, auth.error, auth.isAuthenticated, auth.signinRedirect]);


    if (auth.error) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px', color: 'red' }}>
                <h1>Login Fehlgeschlagen</h1>
                <p>Fehler: {auth.error.message}</p>
                <p>Möglicherweise hast du keine Berechtigung für diese App in OneLogin.</p>
                <button onClick={() => window.location.replace(window.location.origin)}>
                    Zurück zum Start (Retry)
                </button>
            </div>
        );
    }

    // // 2. Lade-Zustand anzeigen
    // if (auth.isLoading) {
    //     return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</div>;
    // }
    // Status-Handling
    if (auth.isLoading) {
        // Hier könntest du einen schönen Lade-Kringel (CircularProgress) anzeigen
        return <div style={{display:'flex', justifyContent:'center', marginTop:'20%'}}>Lade Search Librarian...</div>;
    }

    // 3. Wenn immer noch nicht authentifiziert (z.B. Redirect läuft noch), nichts anzeigen
    if (!auth.isAuthenticated) {
        return null;
    }

    // 4. Prüfen, ob der User ein Mitarbeiter ist (CUAR enthält 'employee')
    // Der Zugriff auf params hängt vom Scope in index.js ab!
    const cuar = auth.user?.profile?.params?.CUAR;

    // Sicherheitshalber Array oder String prüfen
    const isEmployee = cuar && (Array.isArray(cuar) ? cuar.includes('employee') : cuar.includes('employee'));

    if (!isEmployee) {
        return (
            <div style={{ textAlign: 'center', marginTop: '100px', fontFamily: 'sans-serif' }}>
                <h1 style={{ color: '#d32f2f' }}>Zugriff verweigert / Access Denied</h1>
                <p style={{ fontSize: '18px' }}>
                    Dieser Service ist nur für Mitarbeiter. <br />
                    This Service is for employees only.
                </p>
                <div style={{ marginTop: '20px', padding: '15px', background: '#f5f5f5', display: 'inline-block', borderRadius: '8px' }}>
                    <p style={{ margin: 0 }}>Bei Fragen wenden Sie sich bitte an:</p>
                    <a href="mailto:cs-tools@copadata.com" style={{ fontWeight: 'bold', color: '#0056b3' }}>
                        cs-tools@copadata.com
                    </a>
                </div>
                <br /><br />
                <button
                    onClick={() => auth.signoutRedirect()}
                    style={{ padding: '10px 20px', cursor: 'pointer', fontSize: '16px' }}
                >
                    Logout
                </button>
            </div>
        );
    }

    // 5. Alles gut? Dann zeige die App
    return children;
};

export default ProtectedRoute;